<template lang="pug">
	.geo-targets-list
		MapSelector(v-bind="$props", @select-target="v => selectedGeoTargetPlace = v", @resize="v => innerHeight = v",
			@create="v => linkUnlinkTargets(v)", :geoJsonDrawings="geoJsonDrawings")
			.flex-col.space
				ListView.full-width(ref="targetsListView", initialView="table", :height="height || (innerHeight - 20)", :searchVisible="false", :showColumnHeaders="false", :topPagerVisible="false",
					:hideViewsSelection="true", :getTotal="(r) => 0", :getItems="(r) => r", :pageSize="999", :getData="() => linkedTargets || []", selectionMode="single",
					:columns="[{ dataField: 'Name', cellTemplate: 'displayTemplate' }]", valueExpr="LinkedTarget.Oid", @selection="onSelect", :selectedRowKeys="selectedGeoTargetsKeys")
					template(v-slot:displayTemplate="{ data }")
						.flex-col
							.flex-row.justify.space.align-center
								.flex-row.space.align-center
									.target-name.overflow(:title="data.LinkedTarget.Name") {{data.LinkedTarget.Name}}
									slot(name="target-header", :target="data.LinkedTarget")
								.actions.flex-row.space
									.ui-button.hover.scale.align-center.center.flex-row(@click.stop="() => linkUnlinkTargets(data.LinkedTarget, true)")
										i.fas.fa-times
							.target-info.flex-row.space-large.grey.font-small(v-if="data.LinkedTarget.Radius")
								.flex-row.space
									span {{$tCaption('Radius')}}
									span {{cartoApi.getRadiusDividedValue(data.LinkedTarget.Radius)}} {{kmOrMiles}}
								.flex-row.space
									span {{$tCaption('Lat')}}
									span {{data.LinkedTarget.Lat}}
								.flex-row.space
									span {{$tCaption('Lng')}}
									span {{data.LinkedTarget.Lng}}
					.flex-row.space.align-center(slot="left-actions")
						.flex-row.space.justify
							Dropdown.flex-1(
								ref="projectsDD",
								:getTotal="(data) => null", :getItems="(data) => data.Results", :getData="$Data.getTargetProjects",
								:columns="[{ dataField: 'Name', caption: $tCaption('Project') }]",
								displayExpr="Name",
								valueExpr="Oid",
								:placeholder="$tCaption('Add from project')",
								:selectedItems="project && project.Oid",
								:showColumnHeaders="false",
								:filtersVisible="false",
								:searchVisible="true",
								:multiple="false",
								:disabled="!!isLoading",
								@select-data="onProjectSelect")
		Popup(v-if="selectFromProject.visible", :popupVisible="selectFromProject.visible" :width="440", :height="520", :title="project && project.Name", :closeOnOutsideClick="false", @hiding="selectFromProject.visible = false")
			ListView.full-width(ref="projectItemsListView", initialView="table", :height="290", :searchVisible="true", :showColumnHeaders="false", :topPagerVisible="false",
				:hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadProjectTargets", :showViewHeader="true"
				:columns="[{ dataField: 'Name', cellTemplate: 'displayTemplate' }]", valueExpr="Oid", selectionMode="multiple", @selection="v => selectFromProject.selectedItems = v || []")
				template(v-slot:displayTemplate="{ data }")
					.flex-col
						.flex-row.justify.space.align-center
							.flex-row.space.align-center
								.target-name.overflow(:title="data.Name") {{data.Name}}
						.target-info.flex-row.space-large.grey.font-small(v-if="data.Radius")
							.flex-row.space
								span {{$tCaption('Radius')}}
								span {{cartoApi.getRadiusDividedValue(data.Radius)}} {{kmOrMiles}}
							.flex-row.space
								span {{$tCaption('Lat')}}
								span {{data.Lat}}
							.flex-row.space
								span {{$tCaption('Lng')}}
								span {{data.Lng}}
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="commitSelectFromProject", :disabled="!selectFromProject.selectedItems.length")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="selectFromProject.visible = false")
</template>

<script>
	import DxTextBox from 'devextreme-vue/text-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';
	import CartoMapComponent from 'view/carto/CartoMapComponent.vue';
	import api from 'view/carto/api.js';
	import MapSelector from 'view/geoTargets/MapSelector.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import Popup from 'app-core/Popup.vue';
	import wkt from 'wicket';
	import circleToPolygon from 'circle-to-polygon';

	export default {
		translationCategory: 'geoTargets.List',
		name: 'geo-targets',
		props: ['height', 'insertionId', 'insertion', 'linkedTargets'],
		components: { DxButton, ListView, CartoMapComponent, DxNumberBox, MapSelector, Dropdown, Popup, DxTextBox },
		data() {
			return {
				isLoading: false,
				innerHeight: 300,
				selectedGeoTargetPlace: null,
				project: null,
				selectFromProject: {
					visible: false,
					selectedItems: []
				},
				selectedExistingGeoTargets: [],
				selectedGeoTargetsKeys: []
			}
		},
		computed: {
			cartoApi() {
				return api;
			},
			kmOrMiles() {
				return api.kmOrMiles();
			},
			geoJsonDrawings() {
				var wktObject = new wkt.Wkt();
				return this.selectedExistingGeoTargets.filter(f => f?.Name?.length > 5).filter(f => f.GeoPolygonWkt || f.Radius).map(f => {
					if (f.Radius) {
						let geoJsonPolygon = circleToPolygon([f.Lng, f.Lat], f.Radius, { numberOfEdges: 32 });
						return geoJsonPolygon;
					} else {
						return wktObject.read(f.GeoPolygonWkt).toJson();
					}
				});
			}
		},
		watch: {
			linkedTargets: {
				handler() {
					this.$refs.targetsListView?.reload();
					this.preselect();
				},
				deep: true
			},
			'selectFromProject.visible'(v) {
				if (!v) {
					this.project = null;
				}
			}
		},
		mounted() {
			if (__DEBUG__) {
				window.insertionGeoTargetsList = this;
				window.wiket = wkt;
			}
			this.preselect();
		},
		destroyed() {
			if (this.$unobserve)
				this.$unobserve();
			delete this.$unobserve;
		},
		methods: {
			preselect() {
				if (__DEBUG__)
					console.debug('Preselect', { targets: this.linkedTargets });
				if (this.linkedTargets?.length) {
					this.onSelect([this.linkedTargets[0]]);
				}
			},
			commitSelectFromProject() {
				this.selectFromProject.selectedItems.map(f => this.$emit('create', f));
				this.selectFromProject.visible = false;
			},
			loadProjectTargets(pageIndex, limit, opts) {
				return !this.project ? Promise.resolve({ Results: [] }) : this.$Data.getTargetProjectLinkedGeoTargets(pageIndex, limit, opts, this.project?.Oid);
			},			
			onSelect(items, selectionInfo) {
				if (__DEBUG__)
					console.debug('On selection', { items, selectionInfo });
				if (this.processSelection)
					this.processSelection(items, selectionInfo);
				this.selectedExistingGeoTargets = items.map(f => f.LinkedTarget);
				this.selectedGeoTargetsKeys = items?.map(f => f?.LinkedTarget?.Oid);
			},
			linkUnlinkTargets(target, unlink) {				
				this.$emit(unlink ? 'remove' : 'create', target);
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.$refs.targetsListView?.reload();
				});
			},
			onProjectSelect(project) {
				this.project = project;
				this.selectFromProject.visible = true;
				this.selectFromProject.selectedItems = [];
			}
		}
	};
</script>
<style lang='scss'>
	.geo-targets-list {
		padding: 4px;
	}
</style>
